import React from 'react'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { DownloadMyPGAsection } from 'components/download-mypga-section'
import TransactionSummary from 'pages/schedule/ReviewBooking/transaction-summary'
import { useStyles } from '../styles'
import PrivateBookingHeader from 'pages/academy/components/private-booking-headerV2'
import StudentCard from 'pages/schedule/components/student-card'
import PracticeSessionActionButtons from '../practice-session-action-buttons'

const PracticeSessionPurchaseConfirmation = ({
  practiceSession,
  fetchedStudent,
}) => {
  const classes = useStyles()

  const { practiceSessionType, reservation, transactions } =
    practiceSession || {}

  const { cardBrand, last4 } = transactions?.[0].registrationPayment || {}

  return (
    <Container className={classes.summaryWrapper} maxWidth="sm">
      <TransactionSummary
        title="Bay Reservation"
        priceInCents={practiceSessionType?.priceInCents}
        salesTaxInCents={practiceSessionType?.salesTaxInCents}
        cardBrand={cardBrand}
        lastDigits={last4}
      />
      <Typography
        variant="h5"
        style={{ marginTop: '36px', marginBottom: '24px' }}
      >
        Details
      </Typography>
      <PrivateBookingHeader
        practiceSession={practiceSessionType}
        facility={practiceSessionType?.spaces[0]?.facility}
        spaceName={practiceSessionType?.spaces[0]?.name}
        reservation={reservation}
      />
      <Divider className={classes.divider} />
      <Grid item xs={12} sm={6} style={{ marginTop: '24px' }}>
        <StudentCard student={fetchedStudent} />
      </Grid>
      <PracticeSessionActionButtons />
      <DownloadMyPGAsection />
    </Container>
  )
}

export default PracticeSessionPurchaseConfirmation
